import { HiOutlineCpuChip } from 'react-icons/hi2';
import { SimsInfo } from '@src/services/dashboard/simsInfo/simsInfoApiSliceTypes';
import { InfoCard } from './infoCard';
import { CheckIcon } from '@heroicons/react/16/solid';
import { fixNumberPrecision } from '@src/utilities/currency';
import { useTheme } from '@src/theme';

type SubAccountsProps = {
    data?: SimsInfo;
};
export const SubAccounts = ({ data }: SubAccountsProps) => {
    const { theme } = useTheme();
    return (
        <div className="flex flex-col gap-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-[1fr_3fr_3fr] w-full max-w-full gap-4">
                <div className="min-w-0">
                    <InfoCard
                        title="Total SIMs"
                        value={data?.totalSims || 0}
                        color="text-primary"
                        style={{ backgroundColor: theme.semantic.surface }}
                    />
                </div>
                <div className="min-w-0">
                    <InfoCard
                        title="Activated"
                        value={data?.activeTotal || 0}
                        color="text-green-400"
                        icon={<CheckIcon width={16} height={16} />}
                        style={{
                            backgroundColor: theme.semantic.infoContainerLight,
                        }}
                        metrics={[
                            {
                                label: 'Installed',
                                value: data?.activeInstalled || 0,
                            },
                            {
                                label: 'Not installed',
                                value: data?.activeNotInstalled || 0,
                            },
                            {
                                label: 'Expired',
                                value: data?.activeExpired || 0,
                            },
                        ]}
                    />
                </div>

                <div className="min-w-0">
                    <InfoCard
                        icon={<HiOutlineCpuChip size={16} />}
                        color="text-primary"
                        title="In-Use"
                        value={data?.inUseTotal || 0}
                        style={{
                            backgroundColor: theme.semantic.infoContainerLight,
                        }}
                        metrics={[
                            {
                                label: 'Data Usage',
                                value:
                                    `${fixNumberPrecision(data?.dataUsageTotal)} ${data?.dataUsageTotalUnit}` ||
                                    0,
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};
